import IFacetCategoryContract from "../models/contracts/FacetCategoryContract";
import { FacetCategories } from "../models/FacetCategories";
import { FacetsViewModel, FacetCategoryViewModel } from "../models/views";

const FACETS_CATEGORIES_MAPPING = {
  [FacetCategories.MembershipBodies]: "memberships",
  [FacetCategories.Nationality]: "nationalities",
  [FacetCategories.Appearance]: "appearances",
  [FacetCategories.EyeColour]: "eyeColors",
  [FacetCategories.HairColour]: "hairColors",
  [FacetCategories.HairLength]: "hairLengths",
  [FacetCategories.FacialHair]: "facialHairs",
  [FacetCategories.VoiceStyle]: "voiceStyle",
  [FacetCategories.BeltNotes]: "beltNotes",
  [FacetCategories.Disability]: "disabilities",
  [FacetCategories.Gender]: "genders",
  [FacetCategories.HeritageAndEthnicity]: "heritageAndEthnicity",
  [FacetCategories.EthnicBackground]: "ethnicBackground",
  [FacetCategories.VisasAndWorkingPermits]: "visasAndPermits",
};

const EXCLUDE_FACET_GROUP_CODE = ["disability_disability"];

export class FacetConverter {
  public static convertToView(
    facetsCategories: IFacetCategoryContract[]
  ): FacetsViewModel {
    const facets = new FacetsViewModel();

    Object.keys(FACETS_CATEGORIES_MAPPING).forEach((key) => {
      const modelKey = FACETS_CATEGORIES_MAPPING[key];
      const category = facetsCategories.find(
        (category) => category.systemName === key
      );
      const categoryViewModel = new FacetCategoryViewModel();

      if (category) {
        categoryViewModel.id = category.id;
        categoryViewModel.maxActiveCount = category.maxActiveCount;
        categoryViewModel.name = category.name;
        categoryViewModel.systemName = category.systemName as FacetCategories;

        for (const group of category.facetGroups) {
          if (!EXCLUDE_FACET_GROUP_CODE.includes(group.code)) {
            categoryViewModel.facets.push(...group.facets);
          }
        }
      }

      if (Boolean(facets[modelKey]) && facets[modelKey].facets.length !== 0) {
        facets[modelKey].facets = [
          ...facets[modelKey].facets,
          ...categoryViewModel.facets,
        ];
      } else {
        facets[modelKey] = categoryViewModel;
      }
    });

    return facets;
  }

  public static convertToContract() {
    throw Error(
      "convertToContract for facets categories has not been implemented."
    );
  }
}
